import { useState } from 'react';
import classnames from 'classnames';
import isEmpty from 'lodash/fp/isEmpty';
import { DateTime } from 'luxon';

import { MochiCard } from '../mochi-card';
import { ChevronDownIcon, CouponFillIcon } from '../icons';

import { HTMLRenderer } from '../quill-html-renderer/quill-html-renderer';
import { COUPON_ITEM_CLASS_NAME } from '../../constants';
import styles from './coupon-item.module.sass';

export const CouponItem = ({ coupon }) => {
  const [isOpen, setIsOpen] = useState(false);


  const {
    name,
    expiresAt,
    effectiveAt,
    descriptions, // deprecated in future
    richTextDescription,
    availableTimes,
    plateNumber,
  } = coupon;

  const isDescriptionEmpty = isEmpty(descriptions) && isEmpty(richTextDescription);

  return (
    <MochiCard className={classnames(styles.root, COUPON_ITEM_CLASS_NAME)}>
      <div
        className={styles.header}
        onClick={() => {
          setIsOpen(prev => {
            if (isDescriptionEmpty) return false;
            return !prev;
          });
        }}
      >
        <div className={styles.left}>
          <CouponFillIcon color="#007AFF" width={28} height={28} />
          {typeof availableTimes === 'number' && availableTimes > 0 && (
            <span className={styles.times}>{availableTimes} 張</span>
          )}
        </div>
        <div className={styles.content}>
          <span className={styles.name}>{name}</span>
          <div className={styles.meta}>
            {effectiveAt && DateTime.now() <= DateTime.fromISO(effectiveAt) && (
              <span className={styles.time}>{`${formatTime(effectiveAt)} 啟用`}</span>
            )}
            <span className={styles.time}>{`${formatTime(expiresAt)} 到期`}</span>

            {plateNumber && <span className={styles.plateBadge}>{`限車牌 ${plateNumber}`}</span>}
          </div>
        </div>
        {!isDescriptionEmpty && (
          <ChevronDownIcon
            className={classnames({
              [styles.chevronOpen]: isOpen,
              [styles.chevron]: true,
            })}
            width={18}
            height={18}
            color="#999999"
          />
        )}
      </div>
      <HTMLRenderer
        className={classnames(
          styles['container'],
          !isOpen && styles.containerHidden,
          isOpen && styles.containerOpen,
          styles.container
        )}
        dangerouslySetInnerHTML={{
          __html: richTextDescription,
        }}
      />
      <div />
    </MochiCard>
  );
};

function formatTime(iso) {
  return DateTime.fromISO(iso).toFormat('yyyy.MM.dd HH:mm');
}
